var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10982_28453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.02303 17.4954C13.1758 17.4954 16.5422 14.1289 16.5422 9.97621C16.5422 5.82348 13.1758 2.45703 9.02303 2.45703C4.8703 2.45703 1.50385 5.82348 1.50385 9.97621C1.50385 14.1289 4.8703 17.4954 9.02303 17.4954Z",
    stroke: "white",
    strokeWidth: 1.50384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02301 13.7358H9.03053",
    stroke: "white",
    strokeWidth: 1.50384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83496 7.72034C7.01174 7.21781 7.36067 6.79405 7.81994 6.52413C8.27921 6.25422 8.81919 6.15555 9.34424 6.24561C9.86929 6.33567 10.3455 6.60864 10.6886 7.01619C11.0317 7.42373 11.2194 7.93954 11.2186 8.47225C11.2186 9.97609 8.96289 10.728 8.96289 10.728",
    stroke: "white",
    strokeWidth: 1.50384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10982_28453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.046,
    height: 18.046,
    fill: "white",
    transform: "translate(0 0.953125)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.0ee0a7d7.svg";
export { ForwardRef as ReactComponent };